import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../assets/css/general-setting/general-setting.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Backdrop from "@mui/material/Backdrop";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import AutoComplete from "../components/autocomplete-input";
import TextFiealdInput from "../components/textFiald";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import CompletePopup from "../components/response-pop-up";
import {
  create_general_setting_complete_api,
  raise_api_call_add_general_setting,
} from "../../redux/general-setting/add-general-setting-reducer";
import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import {
  edit_general_setting_complete_api,
  raise_api_call_edit_general_setting,
} from "../../redux/general-setting/edit-general-setting-reducer";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";
const GeneralSetting = () => {
  const PageLists = useSelector((state: any) => state.GeneralSetting);
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);
  const [activePartner, setActivePartner] = React.useState<null | number>(null);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editData, setEdit] = useState<any>();
  const [search, setSearch] = useState<string>("");
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();
  const validationSchema = Yup.object().shape({
    page: Yup.string().required("page Is Required"),
    key: Yup.string().required("Key Is Required"),
    name: Yup.string().required("Name  Is Required"),
    description: Yup.string().required("Description Is Required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      page: isEdit ? editData.page : "",
      key: isEdit ? editData.key : "",
      name: isEdit ? editData.name : "",
      description: isEdit ? editData.description : "",
      active: isEdit ? editData.active : true,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;
  console.log(editData);

  // page lists
  // submit data types

  type submitData = {
    id?: string;
    page: string;
    key: string;
    name: string;
    description: string;
    active: boolean | string;
  };

  const dispatch = useDispatch();
  const addGeneralSetting = useSelector(
    (state: any) => state.AddGeneralSetting
  );
  const editGeneralSetting = useSelector(
    (state: any) => state.EditGeneralSetting
  );
  // useEffect
  useEffect(() => {
    dispatch(raise_api_call_list_general_setting(""));
    if (addGeneralSetting.data.status) {
      resetForm();
    }
    if (addGeneralSetting.api_completed) {
      setResponsePopup(true);
      dispatch(create_general_setting_complete_api(false));
    }
    if (editGeneralSetting.api_completed) {
      setResponseEdit(true);
      dispatch(edit_general_setting_complete_api(false));
      setResponsePopup(true);
    }
  }, [addGeneralSetting, editGeneralSetting]);

  const submit = (e: submitData) => {
    let data: submitData = {
      page: e.page,
      key: e.key,
      name: e.name,
      description: e.description,
      active: e.active,
    };
    if (isEdit) {
      data.id = editData.id;

      dispatch(raise_api_call_edit_general_setting(data));
    } else {
      dispatch(raise_api_call_add_general_setting(data));
    }
  };

  const pageOption = PageLists.data.status
    ? PageLists.data.result
        .filter((e: any) => {
          if (e.page == "general_setting") {
            return e;
          }
        })
        .map((e: any) => {
          const data = { label: e.description, value: e.description };
          return data;
        })
    : [{ label: "No Page", value: "no Page" }];

  const handleBack = () => {
    setIsEdit(false);
    setActivePartner(null);
    setShowBack(false);
    setTitleContext("General Settings");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    isEdit && setShowBack(true);
  }, [editData, isEdit]);

  useEffect(() => {
    setTitleContext(
      isEdit
        ? editData?.name
        : activePartner === 1000000000000
        ? "Add"
        : "General Settings"
    );
  }, [isEdit]);

  return (
    <div className="partner-details">
      {responsePopup ? (
        <CompletePopup
          data={responseEdit ? editGeneralSetting : addGeneralSetting}
          responsePopup={responsePopup}
          setCompletePopup={(e: any) => {
            setResponsePopup(false);
            setResponseEdit(false);
          }}
        />
      ) : (
        ""
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={PageLists.isLoading ? true : false}
      >
        {/* <CircularProgress color="inherit" /> */}
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>
      <div className="content_container">
        <div
          className={`mini_side_container`}
          style={{
            display:
              isMobile && typeof activePartner === "number"
                ? "none"
                : "initial",
          }}
        >
          <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
            Add General Settings
          </h5>

          <div className="side_search_container">
            <TextField
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Search"
              className="side_search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchImg} alt="search" width="20px" />
                  </InputAdornment>
                ),
                style: {
                  borderRadius: "0px",
                  height: "45px",
                },
              }}
            />
            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                setIsEdit(false);
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "arrows-rotate"]}
              />
            </Button>

            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                setIsEdit(false);
                setActivePartner(1000000000000);
                setShowBack(true);
                setTitleContext("Add");
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "add"]}
              />
            </Button>
          </div>

          <div className="side_content_container">
            {PageLists.data.status
              ? PageLists.data.result
                  .filter((item: any) => {
                    return Object.values(item)
                      .join("")
                      .toLowerCase()
                      .includes(search.toLowerCase());
                  })
                  .map((e: any, key: number) => {
                    // console.log(e);
                    return (
                      <div
                        key={key + 1}
                        onClick={() => {
                          setActivePartner(key);
                          setIsEdit(true);
                          setEdit(e);
                        }}
                        className={`side_content_card`}
                      >
                        <div
                          className={`side_content_mini_card ${
                            activePartner === key ? "active" : ""
                          }`}
                        >
                          <div className="f4 title">{e.name}</div>
                          <div className="side_content_footer">
                            <h4 className="f4 subtitle">{e.description}</h4>
                            {e.status && <h4>{e.status}</h4>}
                          </div>
                        </div>
                      </div>
                    );
                  })
              : ""}
          </div>
        </div>

        <div
          className={`mini_content_container`}
          style={{
            display:
              isMobile && typeof activePartner !== "number"
                ? "none"
                : "initial",
          }}
        >
          <form
            className="scroll_content_container scroll_content_container_2"
            style={{ padding: "20px 25px" }}
          >
            <Grid container rowSpacing={3} columnSpacing={3}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <AutoComplete
                  className="w-100"
                  pageOption={pageOption}
                  name="page"
                  handleBlur={handleBlur}
                  values={values}
                  vari={(e: any) => {
                    setFieldValue("page", e ? e.value : "");
                  }}
                  label="Key 1"
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <TextFiealdInput
                  handleChange={handleChange}
                  name="key"
                  handleBlur={handleBlur}
                  values={values}
                  label="Key 2"
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <TextFiealdInput
                  handleChange={handleChange}
                  name="name"
                  handleBlur={handleBlur}
                  values={values}
                  label="Value"
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <TextFiealdInput
                  handleChange={handleChange}
                  name="description"
                  handleBlur={handleBlur}
                  values={values}
                  label="Description"
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className="field_item">
                  <FormControlLabel
                    value={values.active}
                    control={<Checkbox defaultChecked />}
                    label="Is Active"
                    onChange={handleChange}
                    name="active"
                    labelPlacement="end"
                  />
                </div>
              </Grid>
            </Grid>
          </form>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "15px",
            }}
          >
            <Button
              className="common_btn"
              disableRipple
              onClick={() => {
                if (!addGeneralSetting.isLoading) {
                  handleSubmit();
                }
              }}
            >
              {addGeneralSetting.isLoading || editGeneralSetting.isLoading
                ? "Please wait..."
                : "Submit"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GeneralSetting;
